import { Outlet } from 'react-router-dom';
import TopNav from './TopNav';
import { CommandPalette } from './CommandPalette';
import { WidgetProvider } from '../widget/WidgetProvider';
import { ChatWidget } from '../widget/ChatWidget';

export default function Layout() {
  return (
    <WidgetProvider>
      <div className="flex h-full flex-col">
        <CommandPalette />
        <TopNav />
        <main className="flex-1 overflow-y-auto bg-surface-50 p-4 dark:bg-gray-950 md:p-6">
          <Outlet />
        </main>
        <ChatWidget />
      </div>
    </WidgetProvider>
  );
}
